import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "NewTableRow__td"
}
const _hoisted_2 = {
  key: 1,
  class: "NewTableRow__td"
}
const _hoisted_3 = { class: "NewTableRow__td" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("tr", {
    class: _normalizeClass(["NewTableRow", {
            'NewTableRow--checked': _ctx.checked,
            'NewTableRow--regular': _ctx.regularTable,
            centered: _ctx.isCentered,
        }])
  }, [
    (_ctx.hasCheckboxColumn)
      ? (_openBlock(), _createElementBlock("td", _hoisted_1, [
          (_ctx.$slots['checkbox'])
            ? _renderSlot(_ctx.$slots, "checkbox", { key: 0 })
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(" check ")
              ], 64))
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasIndexColumn)
      ? (_openBlock(), _createElementBlock("th", _hoisted_2, [
          (_ctx.$slots['table-index'])
            ? _renderSlot(_ctx.$slots, "table-index", {
                key: 0,
                tableIndex: _ctx.tableIndex
              })
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.tableIndex), 1)
              ], 64))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("td", _hoisted_3, [
      (_ctx.$slots['actions'])
        ? _renderSlot(_ctx.$slots, "actions", {
            key: 0,
            row: _ctx.row,
            rowindex: _ctx.index
          })
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, j) => {
      return (_openBlock(), _createElementBlock("td", {
        key: `NewTableRow-${j}`,
        class: "NewTableRow__td"
      }, [
        (_ctx.$slots.td)
          ? _renderSlot(_ctx.$slots, "td", {
              key: 0,
              row: _ctx.row,
              parentindex: _ctx.parentIndex,
              rowindex: _ctx.index,
              colindex: j,
              column: column
            })
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.row[column.key]), 1)
            ], 64))
      ]))
    }), 128))
  ], 2))
}